import api from '@/api/api';
import { TId } from '@/features/common';
import { IInterview } from '@/features/interview';
import { parseAPIData } from '@/utils/parsers';

export async function fetchInterview(params: {
  interviewId: TId;
}): Promise<IInterview> {
  const response = await api.get(`/interviews/${params.interviewId}`);
  return parseAPIData<IInterview>(response.data);
}

export async function deleteInterview(params: {
  interviewId: TId;
}): Promise<void> {
  await api.delete(`/interviews/${params.interviewId}`);
}
